import { FC } from "react";
import { Trans } from "react-i18next";

import { t } from "i18n/i18n";
import { ToggleSwitch } from "mds/components/ToggleSwitch";
import { useAppDispatch, useAppSelector } from "store/index";
import { selectIsAssessWithAIModeEnabled } from "store/selectors";
import { aiStateActions } from "store/slices/ai";

export const AssessWithAIModeButton: FC = () => {
  const dispatch = useAppDispatch();
  const isAssessWithAIModeEnabled = useAppSelector(selectIsAssessWithAIModeEnabled);

  const toggleAssessWithAi = () =>
    dispatch(aiStateActions.setAssessWithAIMode(!isAssessWithAIModeEnabled));

  return (
    <div className="flex flex-col gap-1">
      <ToggleSwitch
        className="w-full justify-between text-black-tint-20"
        eventName="Assessment - Auto AI suggestions toggle"
        isSelected={isAssessWithAIModeEnabled}
        kind="white"
        labelStart={
          <div className="flex flex-row items-center justify-center gap-1">
            <Trans i18nKey="assessment_card.ai.toggle" t={t}>
              <div className="flex text-sm font-semibold">Enable Auto AI Suggestions</div>
              <div className="flex text-xs font-normal leading-5">(BETA)</div>
            </Trans>
          </div>
        }
        size="xs"
        onClick={toggleAssessWithAi}
      />
    </div>
  );
};
